<template>
  <div>
    <leo-input
      type="text"
      id="username"
      :label="userIdLabel"
      v-model.trim="$v.username.$model"
      :placeholder="placeholderMessage"
      :error="isError"
      v2
      errorIcon
      :disabled="isDisabled"
      maxLength="50"
      @keydown="onkeydown"
      :autocomplete="autocomplete"
      @blur="$emit('onBlur')"
    >
      <template v-slot:error>
        <span v-if="usernameApiErrMsg">{{ usernameApiErrMsg }}</span>
        <span v-else>{{ !$v.username.required ? requiredUsernameErrorMsg : userInputErrMessage.validEmailAllowed }}</span>
      </template>
    </leo-input>
  </div>
</template>

<script>
import { VueLeoInput } from "@greateasternlife/leo-input";
import { CommonClass } from "@/mixins";
export default {
  name: "UsernameInput",
  components: {
    "leo-input": VueLeoInput,
  },
  mixins: [CommonClass],
  props: {
    isError: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    placeholderLabel: {
      type: String,
      default: "",
    },
    isPlaceholderRequired: {
      type: Boolean,
      default: true,
    },
    errorMsgType: {
      type: String,
      default: "requiredUsername",
    },
    onSubmit: {
      type: Function,
      default: null,
    },
    autocomplete: {
      type: String,
      default: "off",
    },
    usernameApiErrMsg: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      userIdLabel: null,
      userInputErrMessage: this.$getConstant?.messages?.errorMessage,
      isDesktopChannel: false,
    };
  },
  mounted() {
    this.isDesktopChannel = this.$__checkIsDesktopChannel();
    this.userIdLabel = this.isDesktopChannel
      ? this.$getConstant.labels?.MO.userId
      : this.$getConstant.labels?.userId;
    const usernameInputEl = document.getElementById("username"); //  this.$refs.usernameRef;
    const view = this;
    this.observeElement(
      usernameInputEl,
      "value",
      function (oldValue, newValue) {
        console.log(`${oldValue} to ${newValue}`);
        view.$v.username.$model = newValue;
      }
    );
  },
  computed: {
    requiredUsernameErrorMsg() {
      return this.errorMsgType === "requiredUserEmail"
        ? this.userInputErrMessage.requiredUserEmail
        : this.userInputErrMessage.mandatory;
    },
    placeholderMessage() {
      if (this.isPlaceholderRequired) {
        return this.placeholderLabel ? this.placeholderLabel : this.userIdLabel;
      } else return "";
    },
  },
  inject: ["$v"],
  emits: ["onBlur"],
  methods: {
    onkeydown(e) {
      if (e.key === "Enter" && this.onSubmit) {
        this.onSubmit();
      }
    },
    observeElement(element, property, callback, delay = 0) {
      /* eslint-disable */
      let elementPrototype = Object.getPrototypeOf(element);
      if (elementPrototype.hasOwnProperty(property)) {
        let descriptor = Object.getOwnPropertyDescriptor(
          elementPrototype,
          property
        );
        Object.defineProperty(element, property, {
          get: function () {
            return descriptor.get.apply(this, arguments);
          },
          set: function () {
            let oldValue = this[property];
            descriptor.set.apply(this, arguments);
            let newValue = this[property];
            if (typeof callback == "function") {
              if (oldValue !== newValue)
                setTimeout(callback.bind(this, oldValue, newValue), delay);
            }
          },
        });
      }
    },
  },
};
</script>
